// extracted by mini-css-extract-plugin
export default {"header":"ContentHeader_header__-hbTx"};